
const errorCodes = {
    "evt-0": {
        "kr": "정상적으로 등록 되었습니다.",
        "en": "You have successfully registered for the event.",
        "de": "Du hast dich erfolgreich für das Event angemeldet.",
        "fr": "Vous vous êtes inscrit avec succès à l'événement.",
        "es": "Has hecho el registro para el evento con éxito.",
        "pt": "Você se registrou com sucesso no evento.",
        "ru": "Регистрация на событие прошла успешно.",
        "th": "ลงทะเบียนเสร็จสิ้น",
        "jp": "正常に登録されました。",
        "tw": "已正常登入。",
        "id": "You have successfully registered for the event.",
    },
    // 2022.09.06 번역요청
    "evt-109": {
        "kr": "이미 등록된 메일입니다.",
        "en": "This email address has been registered.",
        "de": "Diese E-Mail-Adresse wurde registriert.",
        "fr": "Cette adresse e-mail a été enregistrée.",
        "es": "El correo electrónico fue registrado.",
        "pt": "O endereço de e-mail foi registrado.",
        "ru": "Данный электронный адрес уже зарегистрирован.",
        "th": "อีเมล์นี้ถูกใช้ลงทะเบียนไปแล้ว",
        "jp": "すでに登録済みのメールです。",
        "tw": "已登錄",
        "id": "This email address has been registered.",
    },
    "evt-110": {
        "kr": "이벤트를 찾을 수 없습니다.",
        "en": "Event cannot be found.",
        "de": "Event kann nicht gefunden werden.",
        "fr": "Impossible de trouver l'événement.",
        "es": "El evento no pudo ser encontrado.",
        "pt": "Evento não encontrado.",
        "ru": "Событие не найдено.",
        "th": "ไม่พบหน้ากิจกรรม",
        "jp": "イベントが見つかりません。",
        "tw": "無法找到活動。",
        "id": "Event cannot be found.",
    },
    "evt-111": {
        "kr": "이벤트가 종료 되었습니다.",
        "en": "Event has terminated.",
        "de": "Event ist beendet.",
        "fr": "L'événement est terminé.",
        "es": "El evento se terminó.",
        "pt": "O evento acabou.",
        "ru": "Событие завершилось.",
        "th": "กิจกรรมสิ้นสุดลงแล้ว",
        "jp": "終了したイベントです。",
        "tw": "活動已結束。",
        "id": "Event has terminated.",
    },
    "evt-112": { "kr": "개인정보 수집과 이용 및 이메일 수신 동의란을 확인해주세요.", "en": "Please check the boxes for Consent to Collection and Use of Personal Information and Email Receipt.", "de": "Bitte kreuzen Sie die Kästchen für die Zustimmung zur Erfassung und Verwendung persönlicher Daten und den E-Mail-Empfang an.", "fr": "Veuillez cocher les cases relatives au consentement à la collecte et à l'utilisation des informations personnelles et à la réception de courriers électroniques.", "es": "Por favor checa las cajas para el Consentimiento para Recopilación y Uso de Información Personal y Recepción de Correo", "pt": "Por favor, marque as caixas de Consentimento para Coleta e Uso de Informações Pessoais e Recepção de Email.", "ru": "Пожалуйста, установите флажки на [Согласие на сбор и использование личной информации и получение электронной почты]", "th": "ติ้กที่กล่องเพื่อยอมรับข้อตกลงการเก็บข้อมูลส่วนตัวและการรับอีเมล์", "jp": "個人情報収集及び利用とメール受信同意欄をご確認ください。", "tw": "請確認同意收集和利用個人信息及接受E-mail欄。", "id": "Harap menyetujui pengumpulan dan penggunaan Informasi Pribadi dan Email Receipt." },
    "evt-113": {
        "kr": "그랜드체이스-차원의 추적자- 정보 수신 동의란을 확인해주세요.",
        "en": "Please check the boxes for GrandChase - Dimensional Chaser - Agreement to Information Receipt.",
        "de": "Bitte kreuzen Sie die Kästchen für die GrandChase - Dimensional Chaser - Vereinbarung zum Erhalt von Informationen.",
        "fr": "Veuillez cocher les cases relatives au consentement GrandChase - Dimensional Chaser - Accord de Réception d'Informations.",
        "es": "Por favor checa las cajas para el GrandChase - Dimensional Chaser - Acuerdo para Recepción de Informaciones",
        "pt": "Por favor, marque as caixas de GrandChase - Dimensional Chaser - Acordo para Recepção de Informações.",
        "ru": "Пожалуйста, установите флажки на [GrandChase - Dimensional Chaser - Соглашение о Получении Информации]",
        "th": "GrandChase - Dimensional Chaser - ข้อตกลงในการเก็บข้อมูลเพื่อการโฆษณาติ้กที่กล่องเพื่อยอมรับข้อตกลงการ",
        "jp": "グランドチェイス-次元の追跡者-情報受信同意欄をご確認ください。",
        "tw": "這是參與活動的必備條款。如果不同意將無法參與活動。。"
    },
    "evt-202": {
        "kr": "이벤트 재등록 오류가 발생 하였습니다.",
        "en": "An error has occurred. You have already registered for this event.",
        "de": "Ein Fehler ist aufgetreten. Du hast dich bereits für dieses Event angemeldet.",
        "fr": "Une erreur est survenue. Vous êtes déjà inscrit à cet événement.",
        "es": "Un error sucedió. Ya estás registrado para este evento.",
        "pt": "Um erro ocorreu. Você já se registrou para este evento.",
        "ru": "Произошла ошибка. Вы уже зарегистрировались на это событие.",
        "th": "เกิดข้อผิดพลาด ท่านได้ทำการลงทะเบียนไปแล้ว",
        "jp": "イベントの再登録中にエラーが発生しました。",
        "tw": "重新登入活動發生錯誤。",
        "id": "An error has occurred. You have already registered for this event.",
    },
    "evt-201": {
        "kr": "이벤트 등록 회수를 초과 하였습니다.",
        "en": "You have reached the maximum number of registration for the event.",
        "de": "Du hast die maximale Anzahl an Anmeldungen für Events erreicht.",
        "fr": "Vous avez atteint le nombre maximum d'inscriptions pour l'événement.",
        "es": "Llegaste al número máximo de registros para el evento.",
        "pt": "Você chegou ao número máximo de registros para o evento.",
        "ru": "Достигнуто максимальное количество регистраций на событие.",
        "th": "ท่านได้ทำการลงทะเบียนครบจำนวนครั้งที่กำหนดไปแล้ว",
        "jp": "イベントの登録回数を超過しました。",
        "tw": "已超過活動登入次數。",
        "id": "You have reached the maximum number of registration for the event.",
    },
    "evt-100": {
        "kr": "이벤트 등록 오류가 발생 하였습니다.",
        "en": "An error has occurred in registration.",
        "de": "Bei der Registrierung ist ein Fehler aufgetreten.",
        "fr": "Une erreur s'est produite lors de l'enregistrement.",
        "es": "Un error sucedió en el registro.",
        "pt": "Um erro ocorreu durante o registro.",
        "ru": "При регистрации произошла ошибка.",
        "th": "เกิดข้อผิดพลาดในระหว่างการลงทะเบียน",
        "jp": "イベント登録中にエラーが発生しました。",
        "tw": "登入活動發生錯誤。",
        "id": "An error has occurred in registration.",
    },
    "evt-500": {
        "kr": "알 수 없는 오류가 발생하였습니다. 관리자에게 문의 바랍니다.",
        "en": "An unknown error occurred. Please contact your administrator.",
        "de": "Ein unbekannter Fehler ist aufgetreten. Bitte wende dich an den Administrator.",
        "fr": "Une erreur inconnue s'est produite. Veuillez contacter l'administrateur.",
        "es": "Un error desconocido sucedió. Por favor contacta al administrador.",
        "pt": "Um erro desconhecido ocorreu. Por favor contate o administrador.",
        "ru": "Произошла неизвестная ошибка. Пожалуйста, свяжитесь с администратором.",
        "th": "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ โปรดติดต่อทีมงาน",
        "jp": "不明のエラーが発生しました。管理者にお問い合わせください。",
        "tw": "發生未知錯誤。請諮詢管理員。"
    },
    "evt-501": {
        "kr": "잘못된 접근 입니다. 접근 경로를 확인 하세요",
        "en": "Access to the path is denied. Please check your access path.",
        "de": "Der Zugriff auf den Pfad wird verweigert. Bitte überprüfe deinen Zugriffspfad.",
        "fr": "L'accès au répertoire est refusé. Veuillez vérifier votre répertoire d'accès.",
        "es": "Acceso al camino negado. Por favor, verifica tu camino de acceso.",
        "pt": "Acesso ao diretório negado. Por favor verifique o seu diretório de acesso.",
        "ru": "Доступ к пути запрещён. Пожалуйста, проверьте путь доступа.",
        "th": "การรับรองล้มเหลว โปรดตรวจสอบการเชื่อมต่อของท่าน",
        "jp": "非正常的なアクセスです。経路をもう一度お確かめください。",
        "tw": "無法進入。請確認進入路徑。",
        "id": "Access to the path is denied. Please check your access path.",
    },
    "evt-1100": {
        "kr": "잘못된 값을 입력 하였습니다.",
        "en": "Invalid input.",
        "de": "Ungültige Eingabe.",
        "fr": "Entrée invalide.",
        "es": "Comando inválido.",
        "pt": "Comando inválido.",
        "ru": "Неправильный ввод.",
        "th": "ข้อมูลที่ใส่ไม่ถูกต้อง",
        "jp": "入力内容に誤りがあります。",
        "tw": "輸入了錯誤數值。",
        "id": "Invalid input.",
    },
    "evt-1101": {
        "kr": "Please select an item from the list.",
        "en": "Please select an item from the list.",
        "de": "Bitte wähle ein Item aus der Liste aus.",
        "fr": "Veuillez sélectionner un élément dans la liste.",
        "es": "Por favor elige un ítem de la lista.",
        "pt": "Por favor, escolha um item da lista.",
        "ru": "Пожалуйста, выберите пункт из списка.",
        "th": "โปรดเลือกไอเท็มจากรายการ",
        "jp": "リストから選択してください。",
        "tw": "請從列表中選擇一項。",
        "id": "Please select an item from the list.",
    },
    "evt-1102": {
        "kr": "Please enter your email address.",
        "en": "Please enter your email address.",
        "de": "Gib bitte deine Email-Adresse ein.",
        "fr": "Veuillez saisir votre adresse e-mail.",
        "es": "Por favor inserta tu correo electrónico.",
        "pt": "Por favor, insira seu endereço de email.",
        "ru": "Пожалуйста, введите свой адрес электронной почты.",
        "th": "โปรดตรวจสอบอีเมล์ของท่าน",
        "jp": "メールアドレスを入力してください。",
        "tw": "請輸入您的E-mail地址。",
        "id": "Please enter your email address.",
    },
    "evt-1103": {
        "kr": "Please enter it according to the email format.",
        "en": "Please enter it according to the email format.",
        "de": "Bitte gib es gemäß dem E-Mail-Format ein.",
        "fr": "Veuillez le saisir en respectant le format de l'e-mail.",
        "es": "Por favor insértalo de acuerdo con el formato del correo electrónico.",
        "pt": "Por favor, insira de acordo com o formato de email.",
        "ru": "Пожалуйста, введите его в соответствии с форматом электронной почты.",
        "th": "โปรดตรวจสอบอีเมล์ที่ใส่ว่าถูกต้องตามรูปแบบ",
        "jp": "正しい形式のメールアドレスを入力してください。",
        "tw": "請按照E-mail格式輸入。",
        "id": "Please enter it according to the email format.",
    },
    "evt-1104": {
        "kr": "Please enter a number.",
        "en": "Please enter a number.",
        "de": "Bitte gib eine Nummer ein.",
        "fr": "Veuillez entrer un nombre.",
        "es": "Por favor inserta un número.",
        "pt": "Por favor, insira um número.",
        "ru": "Пожалуйста, введите номер.",
        "th": "โปรดตรวจสอบหมายเลข",
        "jp": "数字を入力してください。",
        "tw": "請輸入號碼。",
        "id": "Please enter a number.",
    },
    "evt-1105": {
        "kr": "Please enter a number only.",
        "en": "Please enter a number only.",
        "de": "Bitte gib nur eine Zahl ein.",
        "fr": "Veuillez entrer un nombre seulement.",
        "es": "Por favor inserta un número solamente.",
        "pt": "Por favor, insira somente um número.",
        "ru": "Пожалуйста, введите только число.",
        "th": "ใส่ได้แค่ตัวเลขเท่านั้น",
        "jp": "数字のみ入力できます。",
        "tw": "請輸入一個數字。",
        "id": "Please enter a number only.",
    },
    "evt-1106": {
        "kr": "Please enter the URL.",
        "en": "Please enter the URL.",
        "de": "Bitte gib die URL ein.",
        "fr": "Veuillez saisir l'URL.",
        "es": "Por favor inserta la URL.",
        "pt": "Por favor, insira a URL.",
        "ru": "Пожалуйста, введите URL.",
        "th": "โปรดตรวจสอบ URL",
        "jp": "URLを入力してください。",
        "tw": "請輸入連結。",
        "id": "Please enter the URL.",
    },
    "evt-1107": {
        "kr": "Please enter it according to the URL format.",
        "en": "Please enter it according to the URL format.",
        "de": "Bitte gib es gemäß dem URL-Format ein.",
        "fr": "Veuillez le saisir en respectant le format de l'URL.",
        "es": "Por favor insértalo de acuerdo con el formado de la URL.",
        "pt": "Por favor, insira de acordo com o formato de URL.",
        "ru": "Пожалуйста, введите его в соответствии с форматом URL.",
        "th": "โปรดตรวจสอบว่า URL ที่ใส่ถูกต้องตามรูปแบบ",
        "jp": "正しい形式のURLを入力してください。",
        "tw": "請按照連結格式輸入。",
        "id": "Please enter it according to the URL format.",
    }

}

export { errorCodes }